import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Data from '../../Common/Database'
import Path from '../../Common/Path'

export default function ProductScreen() {
    const location = useLocation()
    const navigate = useNavigate()
    const [category, setcategory] = useState('')
    const [subCategory, setsubCategory] = useState("")
    const [itemType, setitemType] = useState("")
    const [Product, setProduct] = useState([])
    console.log(category, subCategory, itemType)

    function getProduct(category, subCategory, itemType) {
        let filteredProduct;
        try {
            if (category) {
                if (category === "furniture") {
                    filteredProduct = Data.filter((x) => x.category.split("_")[1] !== "door");
                } else {
                    filteredProduct = Data.filter((x) => x.category.split("_")[1] === category);
                }
            }

            if (subCategory) {
                filteredProduct = filteredProduct?.filter((x) => x.category.split("_")[1] === subCategory);
            }

            if (itemType || category === "all" || (category === "door" && subCategory === "main")) {
                if (category === "all") {
                    filteredProduct = Data.filter((x) => x.category.split("_")[2] === "main")
                } else if (category === "door") {
                    filteredProduct = Data.filter((x) => x.category.split("_")[1] === "door");
                    filteredProduct = filteredProduct.filter((x) => x.category.split("_")[2] === "main")
                    console.log(filteredProduct)
                } else {
                    filteredProduct = filteredProduct.filter((x) => x.category.split("_")[2] === itemType)
                }
            }

            setProduct(filteredProduct || []);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        const category = location.pathname.split("/")[2];
        const subCategory = location.pathname.split("/")[3];
        const itemType = location.pathname?.split("/")[4];
        setcategory(category);
        setsubCategory(subCategory);
        setitemType(itemType)
        getProduct(category, subCategory, itemType);
    }, [location.pathname]);


    return (
        <div className='ProductScreen'>
            <div className="container my-3">


                <div className='my-3 d-block d-md-none'>
                    <div className="h5">Explore our Products</div>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <div onClick={() => navigate(Path.furniture_office)} style={{ width: "150px" }} className={subCategory === "office" && !itemType ? "btn  btn_outline selected" : "btn  btn_outline"}>Office</div>
                        <div onClick={() => navigate(Path.furniture_drawing)} style={{ width: "150px" }} className={subCategory === "drawingroom" && !itemType ? "btn  btn_outline selected" : "btn  btn_outline"}>Drawing Room</div>
                        <div onClick={() => navigate(Path.furniture_kitchen)} style={{ width: "150px" }} className={subCategory === "kitchen" && !itemType ? "btn  btn_outline selected" : "btn  btn_outline"}>Kitchen</div>
                        <div onClick={() => navigate(Path.furniture_cabinet)} style={{ width: "150px" }} className={subCategory === "cabinate" && !itemType ? "btn  btn_outline selected" : "btn  btn_outline"}>Cabinate</div>
                    </div>
                </div>
                <div className='my-3  d-block d-md-none'>
                    <div className="h5">Best Seller</div>
                    <div className="d-flex justify-content-center gap-3 flex-wrap">
                        <div onClick={() => navigate("/product/all/main")} style={{ width: "150px" }} className={category === "all" ? "btn  btn_outline selected" : "btn  btn_outline"}>All</div>
                        <div onClick={() => navigate(Path.furniture_office + "/main")} style={{ width: "150px" }} className={itemType === "main" && subCategory === "office" ? "btn  btn_outline selected" : "btn  btn_outline"}>Office</div>
                        <div onClick={() => navigate(Path.furniture_drawing + "/main")} style={{ width: "150px" }} className={itemType === "main" && subCategory === "drawingroom" ? "btn  btn_outline selected" : "btn  btn_outline"}>Drawing Room</div>
                        <div onClick={() => navigate(Path.furniture_kitchen + "/main")} style={{ width: "150px" }} className={itemType === "main" && subCategory === "kitchen" ? "btn  btn_outline selected" : "btn  btn_outline"}>Kitchen</div>
                        <div onClick={() => navigate(Path.furniture_cabinet + "/main")} style={{ width: "150px" }} className={itemType === "main" && subCategory === "cabinate" ? "btn  btn_outline selected" : "btn  btn_outline"}>Cabinate</div>
                        <div onClick={() => navigate(Path.doors + "/main")} style={{ width: "150px" }} className={category === "door" ? "btn  btn_outline selected" : "btn  btn_outline"}>Doors</div>
                    </div>
                </div>
                <hr className='d-block d-md-none' />
                <div className="h4 text_main text-center">
                    {category === "door"
                        ? "Explore Our Best Door Designs"
                        : "Discover Elegant Furniture Designs"}
                </div>
                <div className="row">
                    {Product &&
                        Product.map((data) => (
                            <div className="col-6 col-md-4 col-lg-3 my-2" key={data.id || data.img}>
                                <div className="prod_img_wrapper">
                                    <img
                                        src={data.img}
                                        alt={data.category}
                                        className="prod_img"
                                        width={"100%"}
                                        style={{ height: category === "door" ? "400px" : "280px" }}
                                    />
                                    <div className="back_product"></div>
                                </div>
                            </div>
                        ))}
                </div>

            </div>
        </div>
    )
}
